import { z } from "zod";

/**
 * ⚠️⚠️ zod JIT'ini o'chiradi — panel CSP'si (`script-src 'self'`,
 * `'unsafe-eval'` YO'Q) uchun.
 *
 * zod 4 `z.object()` QURILISHIDA `new Function("")` bilan `eval`
 * ruxsatini sinaydi (`zod/v4/core/util.js` — `allowsEval`). Sinov
 * `try/catch` ichida, ya'ni ishlash buzilmaydi — lekin qat'iy CSP
 * ushlab olingan `new Function` ni ham `securitypolicyviolation`
 * sifatida qayd etadi. `jitless: true` da sinov umuman bajarilmaydi
 * (zod'ning o'z izohi, `util.js:146`).
 *
 * ⚠️ FAQAT panel uchun — `apps/frontend/src/main.tsx` ning BIRINCHI
 * importi. Backend buni import QILMAYDI: u yerda CSP yo'q, JIT esa
 * tezroq.
 *
 * ⚠️ Nima uchun alohida modul, `main.tsx` tanasida EMAS: ES importlari
 * ko'tariladi — tana bajarilguncha `App` va `shared/env` allaqachon
 * baholangan, sxemalar qurilgan bo'lardi. Qorovul:
 * `apps/frontend/src/zod-jitless-order.test.ts`.
 */
z.config({ jitless: true });
